import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
// import jsPDF from 'jspdf';
import "jspdf-autotable";

export const formatAmount = (amount) => {
  if (amount == null) return "";
  const fixedAmount = parseFloat(amount).toFixed(2);
  const parts = fixedAmount.split(".");
  const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `₦${withCommas}.${parts[1]}`;
};

export const convertTimestampToReadable = (timestamp) => {
  const date = new Date(timestamp);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const year = date.getUTCFullYear();
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = monthNames[date.getUTCMonth()];
  let hours = date.getUTCHours();
  const amPM = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  return `${month} ${day}, ${year} | ${hours}:${minutes}${amPM}`;
};

export const getDates = (previousDays = 0) => {
  const today = new Date();
  const daysAgo = new Date(today);
  daysAgo.setDate(today.getDate() - previousDays);
  return {
    start_date: daysAgo.toISOString().substr(0, 10),
    end_date: today.toISOString().substr(0, 10),
  };
};
export const exportToExcel = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

export const downloadCSV = (data, fileName) => {
  const csv = convertToCSV(data);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = window.URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", fileName + ".csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
};

function convertToCSV(data) {
  const header = Object.keys(data[0]).join(",");
  const rows = data.map((row) => Object.values(row).join(","));
  return [header, ...rows].join("\n");
}